<template>
    <div style="width: 100%;">
        <v-row justify="center">
            <v-col cols="12" lg="3" md="5" sm="7">
                <v-card shaped raised>
                    <v-card-title>
                        Anmelden
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" lazy-validation v-model="valid">
                            <v-text-field label="E-Mail-Adresse" :rules="emailRules" v-model="user.email" prepend-inner-icon="mdi-at" clearable></v-text-field>
                            <v-text-field label="Passwort" :rules="[v => !!v || 'Passwort wird benötigt.']" v-model="user.password" type="password" prepend-inner-icon="mdi-form-textbox-password" clearable></v-text-field>
                            <v-btn class="mt-3" color="secondary" block :disabled="!valid" @click="postData">Anmelden</v-btn>
                            <v-btn class="mt-3" color="secondary" block text :to="{ name: 'AuthForgotPassword'}">Passwort vergessen</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>

    export default {
        name: "auth-login-content",
        data: () => ({
            valid: true,
            user: {
                email: '',
                password: '',
            },
            emailRules: [
                v => !!v || 'E-Mail-Adresse wird benötigt.',
                v => /.+@.+\..+/.test(v) || 'E-Mail-Adresse ist ungültig.',
            ],
        }),
        methods: {
            postData() {
                if (this.$refs.form.validate()){
                    this.$store.dispatch('user/loginUser', this.user)
                    .then(() => {
                        this.$store.dispatch('permission/get').then( () => {
                            this.$router.push({name: 'Dashboard'});
                        });
                    })
                    .catch( (error) => {
                        if (error.data && error.data.message && error.data.message === 'Unauthenticated'){
                            this.$toast.error('Die E-Mail-Adresse und/oder das Passwort ist falsch.');
                        }
                        else{
                            this.$toast.error('Ein Fehler ist aufgetreten.');
                        }

                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>